<script setup lang="ts">
onMounted(() => {
  console.log(1)
})
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
